<template>
  <section id="presentation-view">
    <template v-if="authUser && session && authUser.id === session.tutor_id">
      <v-container fluid>
        <v-row>
          <v-col cols="12" md="6">
            <v-card>
              <v-toolbar dark dense color="primary">
                Scenario
                <v-spacer/>
                <v-btn icon @click="show_scenario =! show_scenario">
                  <v-icon v-if="show_scenario">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </v-toolbar>
              <v-sheet v-if="show_scenario" class="overflow-y-auto" min-height="200px" max-height="400px">
                <v-card-text class="ql-editor" v-if="session.mock.scenario" v-html="session.mock.scenario.body"/>
                <v-card-text v-else>No data available</v-card-text>
              </v-sheet>
            </v-card>

            <template v-if="session.mock">
              <v-card class="mt-4">
                <v-toolbar dense dark color="primary">
                  Candidate instructions
                  <v-spacer/>
                  <v-btn icon @click="show_instruction = !show_instruction">
                    <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
                    <v-icon v-else>mdi-chevron-down</v-icon>
                  </v-btn>
                </v-toolbar>

                <v-sheet class="overflow-y-auto" max-height="500px">
                  <v-card-text class="ql-editor" v-if="session.mock.instruction && show_instruction" v-html="session.mock.instruction.body"></v-card-text>
                </v-sheet>

              </v-card>
            </template>

            <template v-if="session.mock && session.mock.materials">
              <materials-viewer class="mt-4" :items="session.mock.materials"></materials-viewer>
            </template>
          </v-col>

          <v-col cols="12" md="6">
            <v-card>
              <v-toolbar dark dense color="primary">
                <v-btn icon @click="downloadMarksheet">
                  <v-icon>mdi-download</v-icon>
                </v-btn>
                Marksheet
                <v-spacer/>
                <v-btn icon @click="show_marksheet =! show_marksheet">
                  <v-icon v-if="show_marksheet">mdi-chevron-up</v-icon>
                  <v-icon v-else>mdi-chevron-down</v-icon>
                </v-btn>
              </v-toolbar>

              <v-data-iterator :items="tasks" item-key="id"
                               hide-default-footer disable-pagination disable-sort>
                <template v-slot:default="{ items }">
                  <v-card v-for="item in items" :key="item.name" tile>
                    <v-list-item>
                      <v-list-item-content v-text="item.body"/>
                      <v-list-item-action>
                        <v-switch class="my-auto" v-model="item.mark" false-value="0" true-value="1"
                                  hide-details
                                  @change="updateTask(item)"/>
                      </v-list-item-action>
                    </v-list-item>
                    <v-card-text class="pt-0">
                      <v-text-field class="my-auto " label="Comment" dense outlined v-model="item.comment" hide-details
                                    @input="debounceUpdateTask(item)"/>
                    </v-card-text>
                  </v-card>
                </template>
              </v-data-iterator>

              <v-sheet v-if="show_marksheet" class="overflow-y-auto" max-height="400px">



                <!--                <v-data-table :headers="mark_sheet_headers"-->
                <!--                              :items="session.tasks"-->
                <!--                              hide-default-footer-->
                <!--                              disable-pagination-->
                <!--                              disable-sort-->
                <!--                              disable-filtering-->
                <!--                              dense-->
                <!--                              :calculate-widths="true"-->
                <!--                >-->
                <!--                  <template v-slot:item.mark="{item}">-->
                <!--                    <v-switch class="my-auto" v-model="item.mark" false-value="0" true-value="1"-->
                <!--                              hide-details-->
                <!--                              @change="updateTask(item)"/>-->
                <!--                  </template>-->
                <!--                  <template v-slot:item.comment="{item}">-->
                <!--                    <v-text-field class="my-auto" outlined v-model="item.comment" hide-details @input="debounceUpdateTask(item)"/>-->
                <!--                  </template>-->
                <!--                </v-data-table>-->
              </v-sheet>

            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </template>

    <template v-if="authUser && session && authUser.id === session.user_id">
      <v-container fluid>
        <v-card class="mb-3">
          <v-toolbar dark dense color="primary">
            <v-toolbar-title>Instructions</v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click="show_instruction =! show_instruction">
              <v-icon v-if="show_instruction">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>
          <template v-if="show_instruction">
            <v-sheet v-if="session.mock.instruction" class="overflow-y-auto unselectable" max-height="500px">
              <v-card-text class="ql-editor" v-html="session.mock.instruction.body"></v-card-text>
            </v-sheet>
            <v-sheet v-else class="overflow-y-auto" max-height="500px">
              <v-card-text>No data available</v-card-text>
            </v-sheet>
          </template>
        </v-card>
      </v-container>

      <v-container fluid v-if="session.mock && session.mock.materials">
        <materials-viewer :items="session.mock.materials"></materials-viewer>
      </v-container>

      <v-container fluid>
        <v-card>
          <v-toolbar dark dense color="primary">
            <v-toolbar-title>Mocksheet</v-toolbar-title>
            <v-spacer/>
            <v-btn icon @click="show_mocksheet =! show_mocksheet">
              <v-icon v-if="show_mocksheet">mdi-chevron-up</v-icon>
              <v-icon v-else>mdi-chevron-down</v-icon>
            </v-btn>
          </v-toolbar>

          <v-sheet class="overflow-y-auto" max-height="500px" v-if="show_mocksheet">
            <vue-editor v-model="session.mocksheet" :editor-toolbar="toolbar" @input="debounceUpdateSession"/>
          </v-sheet>
        </v-card>
      </v-container>

      <v-container fluid v-if="session.marked">
        <v-card class="unselectable">
          <template v-if="session.review">
            <v-toolbar dense color="blur">Review</v-toolbar>
            <v-sheet class="overflow-y-auto" min-height="200px" max-height="400px">
              <v-card-text class="ql-editor" v-html="session.review"></v-card-text>
            </v-sheet>
          </template>

          <v-toolbar dense flat color="blur">
            Marks
            <v-spacer/>
            Final mark <v-chip label color="primary px-2 mx-1">{{ session.final_mark}}</v-chip>
          </v-toolbar>
          <v-data-iterator :items="session.marks"
                           disable-pagination
                           disable-filtering
                           hide-default-footer
          >
            <template v-slot:default="props">
              <v-row>
                <v-col cols="12" md="6" class="p-0" v-for="(category, idx) in props.items" :key="idx">
                  <v-card flat tile>
                    <v-card-title> {{ category.name }} <v-spacer/>
                      <v-chip label color="primary px-2 mx-1">{{ category.value }}</v-chip></v-card-title>
                    <v-divider/>
                    <v-list-item v-for="(sub_category, i) in category.children" :key="i">
                      <v-list-item-content v-text="sub_category.name"/>
                      <v-list-item-action v-text="sub_category.value"/>
                    </v-list-item>
                  </v-card>
                </v-col>
              </v-row>
            </template>
          </v-data-iterator>
        </v-card>
      </v-container>
    </template>
  </section>
</template>

<script>
import {mapGetters} from "vuex";
import _ from 'lodash'
export default {
  props: {
    session: {
      type: Object,
      default: null
    },
    event_data: {
      type: Object,
      default: null
    }
  },
  data: () => ({
    show_scenario:true,
    show_instruction:true,
    show_marksheet:true,
    show_mocksheet:true,
    show_mark_calculator:true,
    show_mark_criteria:true,
    mark_sheet_headers: [
      { text: '', value: 'body' },
      { text: 'Answered', value: 'mark' },
      { text: 'Comments', value: 'comment', width: '225px' },
    ],
    marking_criteria_headers: [
      { text: 'Mark', value: 'mark' },
      { text: '%', value: 'percent'},
      { text: '', value: 'pass'},
    ],
    marking_criteria_items: [
      {mark: 'A', percent: '100'},
      {mark: 'B', percent: '80'},
      {mark: 'C', percent: '60', pass: 'pass'},
      {mark: 'D', percent: '40'},
      {mark: 'E', percent: '20'},
      {mark: 'F', percent: '0'},
      {mark: 'G', percent: 'N/A'},
    ],

    toolbar: [
      [{ header: [false, 1, 2, 3, 4, 5, 6] }, "bold", "italic", "underline"],
      [{align:""}, {align:"center"}, {align:"right"}, {align:"justify"}],
      [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
      [{ indent: "-1" }, { indent: "+1" }],
      [{ color: [] }, { background: []}],
      ["blockquote", "code-block"],
      ["link", "image", "formula"],
    ],
  }),
  computed: {
    ...mapGetters({profile_type: 'getAuthUserProfileType'}),
    tasks: function () {
      if(this.session) {
        let tasks = this.session.tasks
        return tasks.sort((a, b) => (a.position - b.position))
      }

      return []
    }
  },
  methods: {
    setFinalMark(mark) {
      this.session.final_mark = mark
      this.updateSession()
    },
    updateTask(item) {
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}/tasks/${item.id}`, {
        mark: item.mark,
        comment: item.comment
      })
    },
    debounceUpdateTask: _.debounce(function (item) { this.updateTask(item)}, 3000),

    //todo change fo student(candidate)
    updateSession() {
      this.axios.put(`api/user/sessions/${this.$route.params.session_id}`, {
        mocksheet: this.session.mocksheet,
      })
    },
    debounceUpdateSession:_.debounce(function () { this.updateSession()}, 3000),
    downloadMarksheet() {
      this.axios({
        url: `api/user/sessions/${this.$route.params.session_id}/marksheet/download`,
        method: 'GET',
        responseType: 'blob',
      })
      .then(response => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'marksheet.pdf'); //or any other extension
        document.body.appendChild(link);
        link.click();
      })
    },
  }
}
</script>
